<template>
    <div class="exam-result-management">
        <h3> 병원코드 관리 > 상세</h3>
        <div class="account-card-box">
            <h2 class="register-title">{{ isEditMode ? '병원정보 수정' : '병원정보 등록' }}</h2>

            <form class="register-form" @submit.prevent="submitAccount">
                <div class="form-row">
                    <label class="form-label" for="name">병원명</label>
                    <input v-model="form.instName" id="name" required class="form-inp" placeholder="병원 이름" />
                </div>
                <div class="form-row">
                    <label class="form-label" for="hospitalCode">병원 코드</label>
                    <input v-if="isEditMode" v-model="form.instCD" id="hospitalCode" required class="form-inp" placeholder="병원 코드 입력" :readonly="isEditMode"/>

                    <div v-if="!isEditMode" style="display: flex; align-items: center;">
                        <input v-model="form.instCD" id="hospitalCode" required class="form-inp-email" placeholder="병원 코드 입력" :readonly="isEditMode"/>
                        <button type="button" class="check-btn-email" @click="CheckCode">중복확인</button>
                    </div>
                </div>

                <div class="form-row">
                    <label class="form-label" for="isActive">사용 여부</label>
                    <select v-model="form.useYN" id="isActive" class="form-inp">
                        <option value="Y">활성화</option>
                        <option value="N">비활성화</option>
                    </select>
                </div>
                <div class="form-actions">
                    <button class="account-btn account-btn--register" type="submit">
                        {{ isEditMode ? '수정' : '등록' }}
                    </button>
                    <button class="account-btn account-btn--edit" type="button" @click="goList">목록</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import api, {urls} from '@/api'


export default {
    name: "HospitalRegister",
    meta: {
        title: "병원코드 관리"
    },
    data() {
        return {
            form: {
                instCD: '',
                instName: '',
                useYN: 'Y',

            },
            isEditMode: false,
        };
    },
    methods: {
        validateForm() {
            // 2. 이름 비어있음 확인
            if (!this.form.instName || this.form.instName.trim() === "") {
                alert("이름을 입력해주세요.");
                return false;
            }

            // 5. 병원코드 비어있음 확인
            if (!this.form.instCD || this.form.instCD.trim() === "") {
                alert("병원코드를 입력해주세요.");
                return false;
            }

            // 6. 병원코드 중복 체크 여부 확인 (예: isEmailChecked)
            if (!this.isEditMode && !this.isEmailChecked) {
                alert("병원코드 중복확인을 해주세요.");
                return false;
            }

            // 모든 체크 통과
            return true;
        },

        submitAccount() {
            if (!this.validateForm()) {
                return // 검증 실패 시 제출 막기
            }

            const url = this.isEditMode ? urls.account.hospitalModify : urls.account.hospitalRegister

            api.post(url, this.form)
                .then(res => {
                    if (res.data === 1) {
                        alert(this.isEditMode ? '병원정보 수정이 완료되었습니다.' : '병원정보 등록이 완료되었습니다.')
                        this.goList()
                    } else {
                        alert(res.data.message || (this.isEditMode ? '병원정보 수정에 실패했습니다.' : '병원정보 등록에 실패했습니다.'))
                    }
                })
                .catch(e => {
                    alert(this.isEditMode ? '병원정보 수정 처리 중 오류가 발생했습니다.' : '병원정보 등록 처리 중 오류가 발생했습니다.')
                    console.error(e)
                })
        },

        loadAccountForEdit(instCD) {
            api.get(urls.account.hospitalSearch, { params: { instCD: instCD } })
                .then(res => {
                    const data = res.data.list && res.data.list[0]
                    if (data) {
                        this.isEditMode = true
                        this.form = {
                            instID: data.inst_id || '',
                            instCD: data.inst_cd || '',
                            instName: data.inst_name || '',
                            useYN: data.use_yn || 'N',
                        }
                    }
                })
                .catch(e => {
                    alert('병원정보 정보 불러오기에 실패했습니다.')
                    console.error(e)
                })
        },

        CheckCode() {
            if (!this.form.instCD) {
                alert('병원코드을 입력해주세요.')
                return
            }

            api.post(urls.account.checkCode, { instID: this.form.instID, instCD: this.form.instCD})
                .then(response => {
                    if (response.data === 0) {
                        alert('이미 사용 중인 병원코드입니다. 다른 병원코드을 입력해주세요.')
                        this.isEmailChecked = false
                    } else {
                        alert('사용 가능한 병원코드입니다.')
                        this.isEmailChecked = true
                    }
                })
                .catch(error => {
                    alert('병원코드 중복 확인 중 오류가 발생했습니다.')
                    console.error(error)
                    this.isEmailChecked = false
                })
        },
        goList() {
            this.$router.push('/account/HospitalManagement')   // 등록 모드에는 사용자 관리 페이지로
        }

    },
    mounted() {
        const instCD = this.$route.query.id;
        // const level = this.$route.query.level
        if (instCD !== undefined) {
            // 수정 모드일 때
            this.loadAccountForEdit(instCD);
        }
    }

};
</script>
